module.exports = __webpack_public_path__ + "static/media/CSS-01.abdc5678.svg";